import ProductList from "../components/ProductList/ProductList";


const Products = () => {
  return (
    <div>
      <ProductList />
    </div>
  );
};

export default Products;